// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-link {
  color: var(--color-gray03);
  cursor: pointer;
}
.text-ps {
  color: var(--color-gray07);
}
.text-ul {
  .text-li::before {
    content: ""; 
    display: inline-block;
    width: 7px; 
    height: 7px; 
    background-color: black; 
    border-radius: 50%;
    margin-right: 8px;
    margin-bottom:3px;
  }
  .text-li {
    font-size: 16px;
    line-height: 1.5;
  }
}
.text-red {
  color: var(--color-qmir-orange) !important;
}
.text-blue {
  color: var(--color-gray03) !important;
}
.text-click {
  cursor: pointer;
}

.text-hover {
  cursor: pointer;
  &:hover {
    transition: 0.3s;
    color: var(--color-gray03) !important;
  }
}
.text-delete {
  text-decoration-line: line-through;
}

.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-cancel {
  text-decoration: line-through;
}
.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-w100 {
  width: 100px;
}

.pw-show {
  display: none;
}
.pw-show.error {
  display: inline;
  color: var(--color-qmir-orange);
}

.text-require {
  &::after {
  content: ' * ';
  vertical-align: middle;
  color: var(--color-qmir-orange);
 }
}

.text-reference {
  color: var(--color-gray10);
}

.text-alert {
  margin: 40px 0;
  font-size: 20px !important;
  color: var(--color-gray03);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/text.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf;IACE,gBAAgB;IAChB,qCAAqC;EACvC;AACF;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE;EACA,cAAc;EACd,sBAAsB;EACtB,+BAA+B;CAChC;AACD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B","sourcesContent":[".text-link {\r\n  color: var(--color-gray03);\r\n  cursor: pointer;\r\n}\r\n.text-ps {\r\n  color: var(--color-gray07);\r\n}\r\n.text-ul {\r\n  .text-li::before {\r\n    content: \"\"; \r\n    display: inline-block;\r\n    width: 7px; \r\n    height: 7px; \r\n    background-color: black; \r\n    border-radius: 50%;\r\n    margin-right: 8px;\r\n    margin-bottom:3px;\r\n  }\r\n  .text-li {\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n  }\r\n}\r\n.text-red {\r\n  color: var(--color-qmir-orange) !important;\r\n}\r\n.text-blue {\r\n  color: var(--color-gray03) !important;\r\n}\r\n.text-click {\r\n  cursor: pointer;\r\n}\r\n\r\n.text-hover {\r\n  cursor: pointer;\r\n  &:hover {\r\n    transition: 0.3s;\r\n    color: var(--color-gray03) !important;\r\n  }\r\n}\r\n.text-delete {\r\n  text-decoration-line: line-through;\r\n}\r\n\r\n.text-left {\r\n  text-align: left;\r\n}\r\n.text-center {\r\n  text-align: center;\r\n}\r\n.text-right {\r\n  text-align: right;\r\n}\r\n.text-cancel {\r\n  text-decoration: line-through;\r\n}\r\n.text-ellipsis {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.text-w100 {\r\n  width: 100px;\r\n}\r\n\r\n.pw-show {\r\n  display: none;\r\n}\r\n.pw-show.error {\r\n  display: inline;\r\n  color: var(--color-qmir-orange);\r\n}\r\n\r\n.text-require {\r\n  &::after {\r\n  content: ' * ';\r\n  vertical-align: middle;\r\n  color: var(--color-qmir-orange);\r\n }\r\n}\r\n\r\n.text-reference {\r\n  color: var(--color-gray10);\r\n}\r\n\r\n.text-alert {\r\n  margin: 40px 0;\r\n  font-size: 20px !important;\r\n  color: var(--color-gray03);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
